import { Table } from '@material-ui/core'
import { Descontos } from 'models/Viabilidade/Descontos'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowCinza, TableRowBranca, TableCellValor, TableCellSubItem } from '../index.style'

const CartaoDescontos: React.FC<{ dados: Descontos }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableDescontos">
        <TableRowCinza>
          <TableCellLabel>R$ Tabela</TableCellLabel>
          <TableCellValor data-cy="campoTabela">
            <NumberFormat
              value={dados?.tabela}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellSubItem>(-) R$ Alçada/Indicação Premiada</TableCellSubItem>
          <TableCellValor data-cy="campoAlcadaIndicacaoPremiada">
            <NumberFormat
              value={dados?.alcadaIndicacaoPremiada}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>R$ Proposta</TableCellLabel>
          <TableCellValor data-cy="campoProposta">
            <NumberFormat
              value={dados?.proposta}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellSubItem>(-) R$ Méd. ITBI</TableCellSubItem>
          <TableCellValor data-cy="campoMediaItbi">
            <NumberFormat
              value={dados?.mediaItbi}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>(-) R$ Méd. Bom Pagador</TableCellSubItem>
          <TableCellValor data-cy="campoMediaBomPagador">
            <NumberFormat
              value={dados?.mediaBomPagador}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>(-) R$ Méd. Outros descontos</TableCellSubItem>
          <TableCellValor data-cy="campoMediaOutrosDescontos">
            <NumberFormat
              value={dados?.mediaOutrosDescontos}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowCinza>
          <TableCellLabel>R$ Gerencial</TableCellLabel>
          <TableCellValor data-cy="campoGerencial">
            <NumberFormat
              value={dados?.gerencial}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowBranca>
          <TableCellSubItem>(+) R$ Méd. Correção</TableCellSubItem>
          <TableCellValor data-cy="campoMediaCorrecao">
            <NumberFormat
              value={dados?.mediaCorrecao}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
        <TableRowBranca>
          <TableCellSubItem>(-) R$ Méd. PDD</TableCellSubItem>
          <TableCellValor data-cy="campoMediaPdd">
            <NumberFormat
              value={dados?.mediaPdd}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowBranca>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoDescontos
